export const PAGE_TRANSITION = {
  out: {
    opacity: 0,
  },
  in: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: 0.2,
    }
  }
};

export const HEADER = {
  in: {
    transition: {
      duration: 0.5,
      staggerChildren: 0.2,
      staggerDirection: 1,
      delayChildren: 1.5,
      type: "spring",
      mass: 0.35,
      stiffness: 75,
    }
  }
};

export const HEADER_ELEMENTS = {
  out: {
    opacity: 0,
    y: 40,
  },
  in: {
    opacity: 1,
    y: 0,
  }
};

export const BLOG_PAGE = {
  out: {
    opacity: 0,
    y: 50,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      mass: 0.35,
      stiffness: 75,
      duration: 1,
      delay: 0.5
    }
  }
};

export const STAGGERED_CONTAINER = {
  in: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: 1,
      delayChildren: 0.4,
    },
  },
};

export const STAGGERED_CHILD = {
  out: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'ease',
      mass: 0.35,
      stiffness: 75,
    },
  },
};